import React from 'react';

import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  checkboxTickContainer: {
    ...common.flexCenter,
    height: 13,
    width: 13,
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 1,
    '&$error': {
      border: `1px solid ${theme.palette.error.main}`,
    },
    '&$checked': {
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.primary.main,
    },
  },
  error: {},
  checked: {},
}));

export interface CheckboxTickProps {
  error?: boolean;
  checked?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const TickSvg = React.memo(({ checked }: { checked: boolean }) => (
  <svg
    width="6"
    height="5"
    viewBox="0 0 6 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ opacity: checked ? 1 : 0 }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.70711 4L6 0.707108L5.29289 0L2 3.29289L0.707107 2L0 2.70711L1.29289 4L2 4.70711L2.70711 4Z"
      fill="white"
    />
  </svg>
));

export const CheckboxTick: React.FC<CheckboxTickProps> = (props) => {
  const { error = false, checked = false, onClick = () => {}, style } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div
      className={clsx(
        classes.checkboxTickContainer,
        error && classes.error,
        checked && classes.checked,
      )}
      style={style}
      onClick={onClick}
    >
      <TickSvg checked={checked} />
    </div>
  );
};
